import styled from 'styled-components'

const AboutStyle = styled.div.attrs((props) => ({ className: props.className }))`
	--paddingSizeTB: var(--sp7x);

	padding-top: calc(var(--sp12x) + var(--headerHeight));
	background-color: var(--grey);

	.about {
		overflow: hidden;
		padding-top: 0 !important;

		.top {
			padding: 0 var(--sp4x);
			margin-bottom: var(--sp12x);

			.second {
				align-self: flex-end;
				display: flex;
				position: relative;

				&.active {
					.word {
						.Neue {
							font-family: var(--dotGotHic);
							font-weight: 400 !important;
						}

						.DotGothic {
							font-family: var(--neue);
							font-weight: 400 !important;
						}
					}
				}

				.original {
					opacity: 0;
					display: flex;
				}

				.copy {
					position: absolute;
					top: 0;
					right: 0;
					display: flex;

					.word {
						margin: 0 var(--sp2x);
						display: flex;

						&:nth-child(1) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(0, -20px);
									}

									&:after {
										transform: translate(0, 30px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -60px);
									}
								}
							}
						}

						&:nth-child(2),
						&:nth-child(3) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-80px, -60px);
									}

									&:after {
										transform: translate(0, 40px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -20px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}
						&:nth-child(4) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-80px, -30px);
									}

									&:after {
										transform: translate(50px, 45px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -20px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}

						span {
							&:nth-child(3n) {
								position: relative;

								&:before {
									content: '';
									position: absolute;
									width: var(--pixelSize);
									height: var(--pixelSize);
									background-color: var(--black);
									animation: pixels3 2s infinite steps(2, end);
								}

								&:after {
									content: '';
									position: absolute;
									width: var(--pixelSize);
									height: var(--pixelSize);
									background-color: var(--black);
									animation: pixels4 2s infinite steps(2, end) reverse;
								}
							}

							&:nth-child(3n-1) {
								position: relative;
							}

							&:nth-child(3n-2) {
								position: relative;

								&:before {
									content: '';
									position: absolute;
									width: var(--pixelSize);
									height: var(--pixelSize);
									background-color: var(--black);
									animation: pixels3 2s infinite steps(2, end);
								}

								&:after {
									content: '';
									position: absolute;
									width: var(--pixelSize);
									height: var(--pixelSize);
									background-color: var(--black);
									animation: pixels4 2s infinite steps(2, end) reverse;
								}
							}
						}
					}
				}
			}
		}

		.snake {
			position: relative;

			.snake-text {
				position: absolute;
				top: 50%;
				right: 0;
				width: 50%;
				transform: translateY(-50%);
				padding-right: var(--sp2-5x);

				p {
					font-size: var(--h6);
					font-family: var(--neue);
					font-weight: 400 !important;
					margin: var(--sp2x) 0;
					display: inline-block;
				}

				.middle-text {
					margin: var(--sp6x) 0;
				}
			}

			.controls {
				position: absolute;
				left: var(--sp4x);
				bottom: var(--sp4x);
				max-width: 154px;

				.buttons {
					margin-bottom: var(--sp3x);

					div {
						width: var(--sp5-5x);
						height: var(--sp5-5x);
						background-color: var(--black);
						position: relative;

						&:before {
							content: '';
							clip-path: polygon(50% 0, 0 100%, 100% 100%);
							background-color: var(--white);
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							width: var(--sp3x);
							height: var(--sp1-5x);
						}

						&.top-btn {
							position: absolute;
							left: 50%;
							bottom: calc(100% + var(--sp1-5x));
							transform: translate(-50%, 0);
						}

						&.left-btn {
							transform: rotate(-90deg);
						}

						&.right-btn {
							transform: rotate(90deg);
						}

						&.bottom-btn {
							margin: 0 var(--sp1-5x);
							transform: rotate(180deg);
						}
					}
				}
			}
		}

		.bottom {
			align-items: flex-start;
			padding: var(--sp17x) var(--sp4x);
			margin-top: var(--sp22-5x);
			position: relative;

			svg {
				position: absolute;
				bottom: 100%;
				left: 0;
				width: 165vw;
				height: auto;
				transform: translateY(var(--sp0-25x));

				&.active {
					g {
						rect {
							opacity: 1 !important;
						}
					}
				}
			}

			.canv {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				z-index: -1;

				&.active {
					& > div {
						opacity: 1;
					}
				}

				& > div {
					position: absolute;
					opacity: 0;
				}
			}

			canvas {
				width: 100%;
				position: absolute;
				top: 0;
				left: 0;
				z-index: -1;
			}

			.second {
				display: flex;
				position: relative;

				&-t {
					margin: var(--sp4x) 0 var(--sp2x);
				}

				&.active {
					.word {
						.Neue {
							font-family: var(--dotGotHic);
							font-weight: 400 !important;
						}

						.DotGothic {
							font-family: var(--neue);
							font-weight: 400 !important;
						}
					}
				}

				.original {
					opacity: 0;
					display: flex;
				}

				.copy {
					display: flex;
					position: absolute;
					top: 0;
					left: 0;
					display: flex;

					.word {
						margin: 0 var(--sp2x);
						display: flex;

						&:nth-child(1) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(0, -30px);
									}

									&:after {
										transform: translate(-30px, 40px);
									}
								}
								&:nth-child(2) {
									&:before {
										transform: translate(0, -40px);
									}

									&:after {
										transform: translate(0, 30px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(4) {
									&:before,
									&:after {
										display: none;
									}
								}
							}
						}

						&:nth-child(2) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-40px, -65px);
									}

									&:after {
										transform: translate(30px, 65px);
									}
								}
								&:nth-child(2) {
									&:before {
										transform: translate(-40px, -10px);
									}

									&:after {
										transform: translate(0, 10px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -20px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}
						&:nth-child(3) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-40px, -65px);
									}

									&:after {
										transform: translate(-90px, 0px);
									}
								}
								&:nth-child(2) {
									&:before {
										transform: translate(-40px, -40px);
									}

									&:after {
										transform: translate(0, 10px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -20px);
									}
								}
								&:nth-child(4) {
									&:after {
										transform: translate(0, 20px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}

						span {
							&:nth-child(3n) {
								position: relative;

								&:before {
									content: '';
									position: absolute;
									width: var(--pixelSize);
									height: var(--pixelSize);
									background-color: var(--black);
									animation: pixels1 1.5s infinite steps(3, end);
								}
							}

							&:nth-child(3n-1) {
								position: relative;

								&:before {
									content: '';
									position: absolute;
									width: var(--pixelSize);
									height: var(--pixelSize);
									background-color: var(--black);
									animation: pixels1 1.5s infinite steps(3, end) reverse;
								}
							}

							&:nth-child(3n-2) {
								position: relative;

								&:after {
									content: '';
									position: absolute;
									width: var(--pixelSize);
									height: var(--pixelSize);
									background-color: var(--black);
									animation: pixels2 2s infinite steps(3, end) reverse;
								}
							}
						}
					}
				}
			}

			.third {
				align-self: flex-end;
			}

			.block {
				display: flex;
				position: relative;

				.second {
					margin-bottom: 0;

					.copy {
						.word {
							&:nth-child(1) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(0, -30px);
										}

										&:after {
											transform: translate(-30px, 40px);
										}
									}
									&:nth-child(2) {
										&:before {
											transform: translate(0, -40px);
										}

										&:after {
											transform: translate(0, 30px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(4) {
										&:before,
										&:after {
											display: none;
										}
									}
								}
							}

							&:nth-child(2),
							&:nth-child(3),
							&:nth-child(4) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(-40px, -65px);
										}

										&:after {
											transform: translate(-90px, 40px);
										}
									}
									&:nth-child(2) {
										&:before {
											transform: translate(-40px, -50px);
										}

										&:after {
											transform: translate(0, 10px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -20px);
										}
									}

									&:nth-child(5) {
										&:before {
											transform: translate(-40px, -40px);
										}
										&:after {
											transform: translate(0, 30px);
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(8) {
										&:before {
											display: none;
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(0, -40px);
										}
									}
								}
							}
						}
					}

					&.top {
						position: absolute;
						top: 0;
						left: 100%;

						.comp-title {
							display: flex;

							.word {
								display: flex;
								margin: 0 var(--sp2x);

								&:nth-child(1) {
									span {
										&:nth-child(1) {
											&:before {
												transform: translate(0, 0);
											}

											&:after {
												transform: translate(-30px, 40px);
											}
										}
										&:nth-child(2) {
											&:before {
												transform: translate(0, -40px);
											}

											&:after {
												transform: translate(0, 30px);
											}
										}

										&:nth-child(3) {
											&:before {
												transform: translate(0, 0px);
											}
										}

										&:nth-child(4) {
											&:before,
											&:after {
												display: none;
											}
										}
									}
								}

								&:nth-child(2),
								&:nth-child(3),
								&:nth-child(4) {
									span {
										&:nth-child(1) {
											&:before {
												transform: translate(-40px, -15px);
											}

											&:after {
												transform: translate(-90px, 40px);
											}
										}
										&:nth-child(2) {
											&:before {
												transform: translate(-40px, -50px);
											}

											&:after {
												transform: translate(0, 10px);
											}
										}

										&:nth-child(3) {
											&:before {
												transform: translate(0, -20px);
											}
										}

										&:nth-child(5) {
											&:before {
												transform: translate(-40px, -40px);
											}
											&:after {
												transform: translate(0, 30px);
											}
										}
										&:nth-child(6) {
											&:before {
												transform: translate(0, -60px);
											}
										}

										&:nth-child(8) {
											&:before {
												display: none;
											}
										}

										&:nth-child(9) {
											&:before {
												transform: translate(0, -40px);
											}
										}
									}
								}

								span {
									&:nth-child(3n) {
										position: relative;

										&:before {
											content: '';
											position: absolute;
											width: var(--pixelSize);
											height: var(--pixelSize);
											background-color: var(--black);
											animation: pixels1 2s infinite steps(3, end);
										}
									}

									&:nth-child(3n-1) {
										position: relative;

										&:after {
											content: '';
											position: absolute;
											width: var(--pixelSize);
											height: var(--pixelSize);
											background-color: var(--black);
											animation: pixels2 2.4s infinite steps(3, end);
										}
									}

									&:nth-child(3n-2) {
										position: relative;

										&:before {
											content: '';
											position: absolute;
											width: var(--pixelSize);
											height: var(--pixelSize);
											background-color: var(--black);
											animation: pixels1 1.8s infinite steps(3, end);
										}
									}
								}
							}
						}
					}
				}

				.fourth {
					margin-bottom: 0;
				}
			}

			.fourth {
				align-self: flex-end;
				margin-bottom: var(--sp10x);
			}
		}
	}

	.pre-wrap {
		white-space: pre-wrap;
	}

	.btn-black {
		margin-top: var(--sp10x);
	}

	.padding-style {
		padding: var(--paddingSizeTB) 0;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--paddingSizeTB: var(--sp23x);

		padding-top: calc(var(--sp10x) + var(--headerHeight));

		.about {
			.top {
				padding: 0 var(--sp2-5x);
				margin-bottom: var(--sp6x);

				.second {
					margin-top: var(--sp3-5x);

					.copy {
						.word {
							&:nth-child(1) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(0, -20px);
										}

										&:after {
											transform: translate(-40px, 20px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -60px);
										}
									}
								}
							}

							&:nth-child(2),
							&:nth-child(3) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(-80px, -40px);
										}

										&:after {
											transform: translate(-10px, -20px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(-60px, 0);
										}
									}

									&:nth-child(5) {
										&:before {
											transform: translate(-40px, -40px);
										}
										&:after {
											transform: translate(0, 30px);
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(8) {
										&:before {
											display: none;
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(0, -40px);
										}
									}
								}
							}
							&:nth-child(4) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(-80px, -30px);
										}

										&:after {
											transform: translate(90px, 20px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -20px);
										}
									}

									&:nth-child(5) {
										&:before {
											transform: translate(-40px, -40px);
										}
										&:after {
											transform: translate(0, 30px);
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(8) {
										&:before {
											display: none;
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(0, -40px);
										}
									}
								}
							}
						}
					}
				}
			}

			.snake {
				.snake-text {
					.middle-text {
						margin: var(--sp5x) 0;
					}
				}

				.controls {
					left: var(--sp2-5x);
					bottom: var(--sp2-5x);
					max-width: var(--sp17x);

					.buttons {
						margin-bottom: var(--sp2x);

						div {
							width: var(--sp5x);
							height: var(--sp5x);
							&:before {
								width: var(--sp2-5x);
								height: var(--sp1-5x);
							}

							&.top-btn {
								bottom: calc(100% + var(--spSize));
							}

							&.bottom-btn {
								margin: 0 var(--spSize);
							}
						}
					}
				}
			}

			.bottom {
				padding: var(--sp12x) var(--sp2-5x);
				margin-top: var(--sp17-5x);

				svg {
					width: 229.5vw;
				}

				.second {
					&-t {
						margin: var(--spSize) 0 var(--sp4x);
					}
				}

				.block {
					.second {
						&.top {
							.comp-title {
								.word {
									&:nth-child(1) {
										span {
											&:nth-child(2) {
												&:before {
													transform: translate(0, -40px);
												}

												&:after {
													transform: translate(0, 30px);
												}
											}

											&:nth-child(3) {
												&:before {
													transform: translate(0, -60px);
												}
											}

											&:nth-child(4) {
												&:before,
												&:after {
													display: none;
												}
											}
										}
									}

									&:nth-child(2),
									&:nth-child(3),
									&:nth-child(4) {
										span {
											&:nth-child(2) {
												&:before {
													transform: translate(-40px, -50px);
												}

												&:after {
													transform: translate(0, 10px);
												}
											}

											&:nth-child(3) {
												&:before {
													transform: translate(0, -20px);
												}
											}

											&:nth-child(5) {
												&:before {
													transform: translate(-40px, -40px);
												}
												&:after {
													transform: translate(0, 30px);
												}
											}
											&:nth-child(6) {
												&:before {
													transform: translate(0, -60px);
												}
											}

											&:nth-child(8) {
												&:before {
													display: none;
												}
											}

											&:nth-child(9) {
												&:before {
													transform: translate(0, -40px);
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--paddingSizeTB: var(--sp23x);

		padding-top: calc(var(--sp7-5x) + var(--headerHeight));

		.about {
			.top {
				padding: 0 var(--sp0-5x);
				margin-bottom: var(--sp4x);

				.second {
					margin-top: var(--sp3-5x);

					.copy {
						.word {
							&:nth-child(1) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(0, -20px);
										}

										&:after {
											transform: translate(-40px, 20px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -60px);
										}
									}
								}
							}

							&:nth-child(2),
							&:nth-child(3) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(-80px, -15px);
										}

										&:after {
											transform: translate(-10px, -20px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(-60px, 0);
										}
									}

									&:nth-child(5) {
										&:before {
											transform: translate(-40px, -40px);
										}
										&:after {
											transform: translate(0, 30px);
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(8) {
										&:before {
											display: none;
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(0, -40px);
										}
									}
								}
							}
							&:nth-child(4) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(-80px, -30px);
										}

										&:after {
											transform: translate(90px, 20px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -20px);
										}
									}

									&:nth-child(5) {
										&:before {
											transform: translate(-40px, -40px);
										}
										&:after {
											transform: translate(0, 30px);
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(8) {
										&:before {
											display: none;
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(0, -40px);
										}
									}
								}
							}
						}
					}
				}
			}

			.snake {
				.snake-text {
					padding-right: var(--sp2x);

					.middle-text {
						margin: var(--sp5x) 0;
					}
				}

				.controls {
					left: var(--sp2x);
					bottom: var(--sp2x);
					max-width: var(--sp14x);

					.buttons {
						margin-bottom: var(--sp4x);

						div {
							width: var(--sp4x);
							height: var(--sp4x);

							&:before {
								width: var(--sp2x);
								height: var(--spSize);
							}

							&.top-btn {
								bottom: calc(100% + var(--spSize));
							}

							&.bottom-btn {
								margin: 0 var(--spSize);
							}
						}
					}

					.help-text {
						width: var(--sp16x);
					}
				}
			}

			.bottom {
				padding: var(--sp12x) var(--sp2-5x);
				margin-top: var(--sp14x);

				svg {
					width: 297.8vw;
					transform: translateY(var(--sp0-25x));
				}

				.block {
					.second {
						&.top {
							.comp-title {
								.word {
									margin: 0 var(--spSize);

									&:nth-of-type(1) {
										span {
											&:nth-child(1) {
												&:before {
													transform: translate(-10px, 10px);
												}
											}
											&:nth-child(2) {
												&:after {
													transform: translate(0, -10px);
												}
											}
										}
									}

									&:nth-of-type(2) {
										span {
											&:nth-child(1) {
												&:before {
													transform: translate(0, 0);
												}
											}
											&:nth-child(2) {
												&:after {
													transform: translate(0, 10px);
												}
											}

											&:nth-child(3) {
												&:before {
													transform: translate(0, 5px);
												}
											}
										}
									}
								}
							}
						}
					}
				}

				.second {
					&.top {
						.comp-title {
							.word {
								margin: 0 var(--spSize);
							}
						}
					}

					.copy .word {
						margin: 0 var(--spSize);

						&:nth-of-type(1) {
							span {
								&:nth-child(1) {
									&:after {
										transform: translate(30px, 85px);
									}
								}
								&:nth-child(2) {
									&:before {
										transform: translate(0, 10px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}

						&:nth-of-type(2),
						&:nth-of-type(3),
						&:nth-of-type(4) {
							span {
								&:nth-child(2) {
									&:before {
										transform: translate(-40px, -75px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, 5px);
									}
								}
								&:nth-child(4) {
									&:after {
										transform: translate(0, -5px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(0, 10px);
									}
									&:after {
										transform: translate(0, 20px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -30px);
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -10px);
									}
								}
							}
						}
					}

					&-t {
						margin: var(--sp2x) 0 var(--sp3x);

						.word {
							margin: 0 var(--spSize);
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--paddingSizeTB: var(--sp15x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--paddingSizeTB: 0;

		padding-top: calc(var(--sp7-5x) + var(--headerHeight));

		.about {
			.top {
				padding: 0 var(--sp2x);
				margin-bottom: var(--sp3x);

				.second .copy {
					.word {
						&:nth-child(1) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(0, 10px);
									}

									&:after {
										transform: translate(-40px, 0);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -60px);
									}
								}
							}
						}

						&:nth-child(2),
						&:nth-child(3) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-80px, 25px);
									}

									&:after {
										transform: translate(-10px, -20px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(-60px, 5px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}
						&:nth-child(4) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-70px, 10px);
									}

									&:after {
										transform: translate(70px, 0);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -20px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}
					}
				}
			}

			.snake {
				width: 100%;
				background-color: var(--yellow);
				overflow: hidden;

				.snake-text {
					padding: var(--sp7-5x) var(--sp2x) var(--sp7-5x) 0;
					position: relative;
					top: unset;
					right: unset;
					width: 100%;
					max-width: var(--sp77x);
					margin-left: auto;
					z-index: 2;

					transform: translate(0);

					.middle-text {
						margin: var(--sp5x) 0;
					}
				}

				.snake-svg {
					position: absolute;
					top: 0;
					width: 100%;
					height: 100%;
				}
			}

			.bottom {
				padding: var(--sp10x) var(--sp2x);
				margin-top: var(--sp12-5x);

				svg {
					width: 401vw;
					transform: translateY(var(--sp0-25x));
				}

				.block {
					.second {
						&.top {
							.comp-title {
								.word {
									margin: 0 var(--spSize);
								}
							}
						}
					}
				}

				.second {
					&.top {
						.comp-title {
							.word {
								margin: 0 var(--spSize);
							}
						}
					}

					.copy .word {
						margin: 0 var(--spSize);

						&:nth-child(1) {
							span {
								&:nth-child(2) {
									&:before {
										transform: translate(0, -20px);
									}

									&:after {
										transform: translate(0, 10px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}

						&:nth-child(2),
						&:nth-child(3),
						&:nth-child(4) {
							span {
								&:nth-child(2) {
									&:before {
										transform: translate(-40px, -30px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -30px);
									}
									&:after {
										transform: translate(0, 25px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -10px);
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -30px);
									}
								}
							}
						}
					}

					&-t {
						margin: var(--sp1-5x) 0 var(--sp2x);
						.word {
							margin: 0 var(--spSize);
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--paddingSizeTB: 0;

		padding-top: calc(var(--sp7-5x) + var(--headerHeight));

		.about {
			.top {
				padding: 0 var(--sp2x);
				margin-bottom: var(--sp4x);

				.second .copy {
					.word {
						&:nth-child(1) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(0, -20px);
									}

									&:after {
										transform: translate(0, 40px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -60px);
									}
								}
							}
						}

						&:nth-child(2),
						&:nth-child(3) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-70px, -35px);
									}

									&:after {
										transform: translate(30px, 35px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(-60px, -5px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}
						&:nth-child(4) {
							span {
								&:nth-child(1) {
									&:before {
										transform: translate(-70px, -30px);
									}

									&:after {
										transform: translate(70px, 25px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -20px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 30px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -60px);
									}
								}

								&:nth-child(8) {
									&:before {
										display: none;
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -40px);
									}
								}
							}
						}
					}
				}
			}

			.snake {
				width: 100%;
				background-color: var(--yellow);
				overflow: hidden;

				.snake-text {
					padding: var(--sp7-5x) var(--sp2x) var(--sp7-5x) 0;
					position: relative;
					top: unset;
					right: unset;
					width: 100%;
					max-width: var(--sp69x);
					margin-left: auto;
					transform: translate(0);
					z-index: 2;

					.middle-text {
						margin: var(--sp5x) 0;
					}
				}

				.snake-svg {
					position: absolute;
					top: 0;
					width: 100%;
					height: 100%;
				}
			}

			.bottom {
				padding: var(--sp10x) var(--sp2x);
				margin-top: var(--sp12-5x);

				svg {
					width: 513vw;
					transform: translateY(var(--sp0-25x));
				}

				.block {
					flex-direction: column;

					.fourth {
						width: 100%;
					}

					.second {
						&.top {
							position: relative;
							top: unset;
							left: unset;
							padding: 0;

							.comp-title {
								.word {
									margin: 0 var(--spSize);

									&:first-child {
										margin-left: 0;
									}
								}
							}
						}
					}
				}

				.second {
					.copy .word {
						margin: 0 var(--spSize);

						&:nth-child(1) {
							span {
								&:nth-child(2) {
									&:before {
										transform: translate(0, -60px);
									}

									&:after {
										transform: translate(0, 60px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0, -50px);
									}
								}
							}
						}

						&:nth-child(2),
						&:nth-child(3),
						&:nth-child(4) {
							span {
								&:nth-child(2) {
									&:before {
										transform: translate(-40px, -65px);
									}
									&:after {
										transform: translate(0px, 65px);
									}
								}

								&:nth-child(3) {
									&:before {
										transform: translate(0px, -65px);
									}
								}

								&:nth-child(5) {
									&:before {
										transform: translate(-40px, -40px);
									}
									&:after {
										transform: translate(0, 50px);
									}
								}
								&:nth-child(6) {
									&:before {
										transform: translate(0, -50px);
									}
								}

								&:nth-child(7) {
									&:after {
										transform: translate(0, 60px);
									}
								}

								&:nth-child(8) {
									&:after {
										transform: translate(0, 60px);
									}
								}

								&:nth-child(9) {
									&:before {
										transform: translate(0, -60px);
									}
								}
							}
						}
					}

					&-t {
						margin: var(--sp1-5x) 0 var(--sp2x);
						.word {
							margin: 0 var(--spSize);
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--paddingSizeTB: 0;

		padding-top: calc(var(--sp7-5x) + var(--headerHeight));

		.about {
			.top {
				padding: 0 var(--sp2x);
				margin-bottom: var(--sp3x);

				.second {
					margin-top: var(--spSize);
					flex-wrap: wrap;
					justify-content: flex-end;

					.comp-title {
						flex-wrap: wrap;
						max-width: var(--sp42x);
					}

					.copy {
						justify-content: flex-end;

						.word {
							&:nth-child(2) {
								width: var(--sp17x);
							}

							&:nth-child(3) {
								margin-left: 0;
							}

							&:nth-child(4) {
								margin-right: auto;
								margin-left: 0;
							}

							&:nth-child(1) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(0, 15px);
										}

										&:after {
											transform: translate(0, -5px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -60px);
										}
									}
								}
							}

							&:nth-child(2),
							&:nth-child(3) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(-35px, -40px);
										}

										&:after {
											transform: translate(20px, 45px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(10px, -30px);
										}
									}

									&:nth-child(5) {
										&:before {
											transform: translate(-40px, -40px);
										}
										&:after {
											transform: translate(0, 30px);
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(8) {
										&:before {
											display: none;
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(0, -40px);
										}
									}
								}
							}
							&:nth-child(4) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(-35px, -25px);
										}

										&:after {
											transform: translate(65px, 35px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -20px);
										}
									}

									&:nth-child(5) {
										&:before {
											transform: translate(-40px, -40px);
										}
										&:after {
											transform: translate(0, 30px);
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -60px);
										}
									}

									&:nth-child(8) {
										&:before {
											display: none;
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(0, -40px);
										}
									}
								}
							}
						}
					}
				}
			}

			.snake {
				width: 100%;
				overflow: hidden;

				.snake-text {
					padding: var(--sp5x) var(--sp2x);
					position: relative;
					top: unset;
					right: unset;
					width: 100%;
					max-width: unset;
					margin-left: auto;
					transform: translate(0);
					z-index: 1;

					.middle-text {
						margin: var(--sp4x) 0;
					}

					p {
						margin: var(--spSize) 0;
					}
				}

				.snake-svg {
					position: absolute;
					top: -1%;
					width: 100%;
					height: 60%;
					z-index: 0;
					left: 40%;
				}
			}

			.bottom {
				padding: var(--sp7-5x) var(--sp2x);
				margin-top: var(--sp7-5x);

				svg {
					width: 950vw;
					transform: translateY(var(--sp0-25x));
				}

				.block {
					flex-direction: column;

					.fourth {
						width: 100%;
					}

					.second {
						&.top {
							position: relative;
							top: unset;
							left: unset;
							padding: 0;

							.comp-title {
								.word {
									margin: 0 var(--spSize);

									&:first-child {
										margin-left: 0;
									}

									&:nth-of-type(1) {
										span {
											&:nth-child(1) {
												&:before {
													transform: translate(0, -35px);
												}

												&:after {
													transform: translate(0, 35px);
												}
											}
											&:nth-child(2) {
												&:before {
													display: none;
												}

												&:after {
													transform: translate(0, 45px);
												}
											}

											&:nth-child(3) {
												&:before {
													transform: translate(0, -30px);
												}
											}
										}
									}

									&:nth-of-type(2),
									&:nth-of-type(3),
									&:nth-of-type(4) {
										span {
											&:nth-child(2) {
												&:before {
													transform: translate(0px, 10px);
												}
												&:after {
													transform: translate(0px, 55px);
												}
											}

											&:nth-child(3) {
												&:before {
													transform: translate(10px, 10px);
												}
											}

											&:nth-child(5) {
												&:before {
													display: none;
												}
												&:after {
													display: none;
												}
											}
											&:nth-child(6) {
												&:before {
													transform: translate(0, -50px);
												}
											}

											&:nth-child(7) {
												&:after {
													transform: translate(0, 60px);
												}
											}

											&:nth-child(8) {
												&:after {
													transform: translate(0, 60px);
												}
											}

											&:nth-child(9) {
												&:before {
													transform: translate(10px, -35px);
												}
											}
										}
									}
								}
							}
						}
					}
				}

				.second {
					.copy .word {
						margin: 0 var(--spSize);
					}

					.comp-title {
						.word {
							&:nth-of-type(1) {
								span {
									&:nth-child(1) {
										&:before {
											transform: translate(0, -35px);
										}

										&:after {
											transform: translate(0, 35px);
										}
									}
									&:nth-child(2) {
										&:before {
											display: none;
										}

										&:after {
											transform: translate(0, 45px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(0, -30px);
										}
									}
								}
							}

							&:nth-of-type(2),
							&:nth-of-type(3),
							&:nth-of-type(4) {
								span {
									&:nth-child(2) {
										&:before {
											transform: translate(0px, 10px);
										}
										&:after {
											transform: translate(0px, 55px);
										}
									}

									&:nth-child(3) {
										&:before {
											transform: translate(10px, 10px);
										}
									}

									&:nth-child(5) {
										&:before {
											display: none;
										}
										&:after {
											display: none;
										}
									}
									&:nth-child(6) {
										&:before {
											transform: translate(0, -50px);
										}
									}

									&:nth-child(7) {
										&:after {
											transform: translate(0, 60px);
										}
									}

									&:nth-child(8) {
										&:after {
											transform: translate(0, 60px);
										}
									}

									&:nth-child(9) {
										&:before {
											transform: translate(10px, -35px);
										}
									}
								}
							}
						}
					}
					&-t {
						margin: var(--spSize) 0 var(--sp1-5x);
						.word {
							margin: 0 var(--spSize);
						}
					}
				}
			}
		}
	}
`
export default AboutStyle
